import { useEffect } from 'react';

import { Navigate } from 'react-router-dom';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import PageLoading from '@zenbusiness/zui/PageLoading';

import { DEFAULT_SEGMENT } from '#client/build-env';
import { OrphanAccountRedirect } from '#client/components/OrphanAccountRedirect';
import { ACCOUNT_TYPES } from '#client/constants/accountTypes';
import { SHOW_ORPHAN_ACCOUNT_OPTIONS } from '#client/constants/experimentsFlags';
import * as ROUTES from '#client/constants/routes';
import { useAccountExperience } from '#client/hooks/useAccountExperience';
import EnterpriseHomeNoEntity from '#client/pages/EnterpriseHome/NoEntity';

export default function Landing() {
  const { authenticated, login } = useAuthentication();
  const { loading: entityLoading, businessEntityUuid } = useBusinessEntity();
  const { accountExperience, loading: accountExperienceLoading } = useAccountExperience();
  const enableVeloRedirectOptions = useExperimentFlag(SHOW_ORPHAN_ACCOUNT_OPTIONS, false);

  useEffect(() => {
    if (!authenticated) {
      login(`${DEFAULT_SEGMENT}/`);
    }
  }, [authenticated, login]);

  if (!authenticated || entityLoading || accountExperienceLoading) {
    return <PageLoading />;
  }

  // User has valid auth + business entity -> navigate to dashboard
  if (businessEntityUuid) {
    return <Navigate to={`${DEFAULT_SEGMENT}/${businessEntityUuid}/`} replace />;
  }

  // Enterprise user has no business entity -> show no-entity content
  if (accountExperience.accountType === ACCOUNT_TYPES.ENTERPRISE) {
    return <EnterpriseHomeNoEntity />;
  }

  // Orphan account: only reached when auth ready + entity loaded + no entity
  if (enableVeloRedirectOptions) {
    return <Navigate to={ROUTES.getStarted} replace />;
  }

  return <OrphanAccountRedirect />;
}
